export default "__VITE_ASSET__T1oayAlG__"